var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 40 40" }, props),
    React.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M20.3 6.1c-7.8 0-14.2 6.3-14.2 14.2 0 7.8 6.3 14.2 14.2 14.2 7.8 0 14.2-6.3 14.2-14.2-.1-7.9-6.4-14.2-14.2-14.2zm0 8.4c1.9 0 3.5 1.2 3.5 3.6 0 2.4-2 5.1-3.5 5.1s-3.5-2.7-3.5-5.1c-.1-2.4 1.5-3.6 3.5-3.6zm-5.4 12.2c0-3 1.3-2.9 3.2-3.3.6.7 1.4 1 2.1 1 .7 0 1.5-.3 2.1-1 1.9.4 3.2.2 3.2 3.2.1 2.1-10.6 2.1-10.6.1z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/products/User.svg